<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">
        <div class="container-fluid py-4">
            <div class="flex justify-end gap-4">
              <b-button class="bg-main" @click="collapse1 = !collapse1" >
                  {{$t('service.addService')}}
                  <Icon :icon="'angle-down'" class="ml-1"/>
              </b-button>
              <b-button class="bg-main" @click="collapse2 = !collapse2">
                  {{$t('additional')}}
                  <Icon :icon="'angle-down'" class="ml-1"/>
              </b-button>
            </div>
            <div :class="{'h-20': collapse1, 'h-0': !collapse1}" class="transition-all">
                <div class="grid grid-cols-12 gap-3 py-5 px-0" v-if="collapse1">
                    <div class="col-span-12 md:col-span-4 relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute bottom-9 ml-2">
                            {{ $t('service.serviceName') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <b-form-input v-model="modelForm.name" class="border-gray-300 h-11 focus:ring-0" @keyup.enter="isNoErrorAddService"/>
                    </div>

                    <div class="col-span-12 md:col-span-4 relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute bottom-9 ml-2">
                            {{ $t('service.price') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <b-form-input v-model="modelForm.price" type="number" class="border-gray-300 h-11 focus:ring-0" @keyup.enter="isNoErrorAddService"/>
                    </div>

                    <div class="col-span-12 md:col-span-2 relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute bottom-9 ml-2">
                            {{ $t('currency') }}<span class="text-red-500 text-xl">*</span>
                        </div>

                        <b-form-select
                            v-model="modelForm.currency"
                            :options="getCurrencies"
                            value-field="id"
                            text-field="shortName"
                            class="border-gray-300 h-11 focus:ring-0"
                        >
                        </b-form-select>
                    </div>

                    <div v-if="!isEditPage" class="col-span-12 md:col-span-2">
                        <b-button
                            :disabled="addDisabled()"
                            class="btn bg-main h-11 w-full font-bold"
                            @click="addService()"
                        >
                            {{ $t('add') }}
                        </b-button>
                    </div>

                </div>
            </div>
            <div :class="{'h-20': collapse2, 'h-0': !collapse2}" class="transition-all">
                <div class="mt-4 grid grid-cols-12 gap-3 p-0" v-if="collapse2">
                    <div class="col-span-10 md:col-span-8 mt-0.5 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-10 ml-2">
                            {{ $t('service.serviceName') }}
                        </div>
                        <b-form-input
                            v-model="search.name"
                            class="h-11 focus:ring-0 border-gray-300"
                            @keyup.enter="searchServices"
                        >
                        </b-form-input>
                    </div>


                    <div class="col-span-10 md:col-span-4">
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-l h-11 mt-0.5 w-50 focus:outline-none">
                            <img src="/images/search1.png" alt="" class="h-6 cursor-pointer" @click="searchServices">
                        </button>
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-r h-11 mt-0.5 w-50 focus:outline-none">
                            <img src="/images/eraser%20(2).png" alt="" class="h-6 cursor-pointer" @click="resetServicesSearchInfo">
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <table class="w-full mt-3" v-if="hasServices">
            <thead>
            <tr class="h-11 bg-lightGray">
                <th class="d-none d-md-table-cell pl-3">#</th>
                <th>{{ $t('service.serviceName') }}</th>
                <th>{{ $t('service.price') }}</th>
                <th>{{ $t('actions') }}</th>
            </tr>
            </thead>
            <tbody
                v-for="service in getServices"
                :key="service.id"
            >
            <tr class="h-11 border-bottom">
                <td class="py-2 d-none d-md-table-cell pl-3">{{ service.id }}</td>
                <td class="py-2">{{ service.name }}</td>
                <td class="py-2">{{ showCurrencyById(service.currency.id, service.price) }}</td>
                <td>
                    <img src="/images/edit.png" alt="" class="h-7 pr-3 cursor-pointer" @click="editService(service.id)">
                    <img @click="$bvModal.show('delete-product-' + service.id)" src="/images/Union.png" alt="" class="h-7 cursor-pointer">
                </td>
            </tr>
            <Modal
                text="deleteConfirm"
                ok-text="yes"
                cancel-text="no"
                :is-ok-only="false"
                :context="{name: service.name}"
                :id="'delete-product-' + service.id"
                :on-ok-pressed="() => {modalOk(service.id)}"
            />
            </tbody>
        </table>

            <PaginationRow
                class="mt-4 ml-4"
                :search="search"
                base-url="services"
                :total-items="getServicesTotalCount"
                method-name="searchService"
            />
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import currencyFormat from "@/mixin/currencyFormatMixin";
import accessMixin from "@/mixin/accessMixin";
import dateFormatting from "@/mixin/dateFormattingMixin";
import PaginationRow from "@/components/PaginationRow";
import Modal from "@/components/html/Modal.vue";
import Row from "@/components/html/Row.vue";
import Icon from "@/components/html/Icon.vue";
export default {
    name: "List",
    components: {Icon, Row, Modal, PaginationRow},
    mixins: [currencyFormat, accessMixin, dateFormatting],
    data() {
        return {
            collapse1: false,
            collapse2: false,
            hasServices: false,
            isEditService: true,
            isEditPage: false,
            isLoading: false,
            services: [],
            modelForm: {
                id: null,
                name: '',
                price: '',
                currency: ''
            },
            search: {
                page: 1,
                name: '',
                isNeedFetch: false
            },
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'service.title'},
            ],
        }
    },
    computed: {
        ...mapGetters(['getServices', 'getServicesTotalCount', 'getCurrencies']),
    },
    methods: {
        ...mapActions(['fetchServices', 'pushServices', 'searchService', 'deleteService', 'setBreadcrumbItems']),
        editService(id) {
            this.$i18nHelper.toUrl('services/edit/' + id)
        },
        modalOk(id) {
            this.$root.showOverlay = true

            this.deleteService(id)
                .then(() => {
                    this.fetchServices(this.search.page)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                })
        },
        openCollapse(foo) {
                this.collapse = foo === this.collapse ? '' : foo
        },
        searchServices() {
            this.$root.showOverlay = true

            this.searchService(this.search)
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                })
        },
        resetServicesSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this))
            this.searchProducts()
        },
        isNoErrorAddService() {
            if (!this.addDisabled() && !this.isEditPage) {
                this.addService()
            }
        },
        addDisabled() {
            return this.modelForm.name === '' || this.modelForm.price === '' || this.modelForm.currency === ''
        },
        addService() {
            this.$root.showOverlay = true

            let newModelForm = {name: '', price: '', currency: this.modelForm.currency}
            this.services.push(this.modelForm)
            this.modelForm = newModelForm

            this.isLoading = true
            let services = []

            for (let service of this.services) {
                services.push({
                    'name': service.name,
                    'price': service.price,
                    'currency': '/api/currencies/' + service.currency
                })
            }

            this.pushServices({serviceDtos: services})
                .then(() => {
                    this.isLoading = false
                    this.fetchServices(1)
                        .finally(() => {
                            this.$root.showOverlay = false
                        })
                })
                .catch(() => {
                    this.$root.showOverlay = false
                })

        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        console.log('mounted')
        console.log(this.search.page)
        this.fetchServices(this.search.page)
            .then(() => {
                this.getServices.length > 0 ? this.hasServices = true : this.hasServices = false
            })

        this.modelForm.currency = this.getUserCompany.baseCurrency.id
    }
}
</script>

<style scoped>

</style>